import { render } from "./ImgFileUpload.vue?vue&type=template&id=7c38e242&scoped=true"
import script from "./ImgFileUpload.vue?vue&type=script&lang=js"
export * from "./ImgFileUpload.vue?vue&type=script&lang=js"

import "./ImgFileUpload.vue?vue&type=style&index=0&id=7c38e242&scoped=true&lang=css"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c38e242"]])

export default __exports__